import { render, staticRenderFns } from "./consultingcategory.vue?vue&type=template&id=2bc1e5a8&"
import script from "./consultingcategory.vue?vue&type=script&lang=js&"
export * from "./consultingcategory.vue?vue&type=script&lang=js&"
import style0 from "./consultingcategory.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports